import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { userModel } from 'projects/admin/src/app/models/userModel.model';
import { throwError } from 'rxjs';

@Injectable() 
export class AppService {
  private apiBaseUrl: string = '';
  private token: string = '';
  TOKEN_NAME: string = 'BWCExemptionToken';

  constructor(http: HttpClient, @Inject('environment') environment: any) {
    // Verify that the apiURL is in the environment variables
    if (
      environment.apiUrl === undefined ||
      environment.apiUrl === null ||
      environment.apiUrl === ''
    ) {
      throwError('WebAPI Value not set in the environment variables');
    }

    this.apiBaseUrl = environment.apiUrl;

    // make sure the apiBaseURL ends with a wack
    if (this.apiBaseUrl.endsWith('/') === false) {
      this.apiBaseUrl = this.apiBaseUrl.concat('/');
    }
  }

  public getEndpoint(route: string) {
    return `${this.apiBaseUrl}${route}`;
  }

  public gethttpOptions() {
    const headers = new HttpHeaders()
      .set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, DELETE')
      .set('Access-Control-Allow-Origin', '*')
      .set('content-type', 'application/x-www-form-urlencoded')
      .set('content-type', 'application/json')
      .set('Authorization', `bearer ${this.getAuthorizationToken()}`);
      const options = {
        headers: headers };
      return options;
  }

// '  public init() {
//     this.http.post(this.getEndpoint('auth'), {userName: "", password: ""})
//   }'

  public gethttpOptionsFormDataContent() {
    const headers = new HttpHeaders()
      // .set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, DELETE')
      // .set('Access-Control-Allow-Origin', '*')
      // .set('Content-Type', 'application/octet-stream')
      .set('Authorization', `bearer ${this.getAuthorizationToken()}`);
      return headers;
  }
  getAuthorizationToken(): string | null {
    return '';
  }
  getUser(): userModel {
    let userInfo = new userModel();
    userInfo.userId = 'XjJyYmloZ2kyYXIz';
    return userInfo;
  }
}
